import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  DsiSvgIcon as SvgIcon,
  DsiIconType as IconType,
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
  TextP,
} from '../../..';
import { getCartItemInfo } from '../../../utilities/selectors';
import { useState } from 'react';
import { formatPrice, prop } from '../../../utilities';
import { __ } from 'react-i18n';
import {
  DsiProductCartTableSaleRow,
  PlusIconWrapper,
} from './ProductCartTableSaleRow';
import { DsiProductCartTableActionSaleRow } from './ProductCartTableActionSaleRow';
import { SetFreeButton } from './ProductCartTableRow';
import { DsiTags as Tags } from '../General/Tags';
import { Link } from 'react-router';

interface Props {
  item: any;
  addToCart: any;
  removeFromCart: any;
  onCountRemoveFromCart?: any;
  isB2B?: boolean;
  updateCart?: any;
  isFree?: boolean;
  theme: any;
  setItemFree?: any;
  previousItem?: any;
  conditionTextMapping?: any;
  isCorporate: boolean;
}

function ProductCartMobileTab(props: Props) {
  const {
    item,
    addToCart,
    removeFromCart,
    onCountRemoveFromCart,
    isB2B,
    updateCart,
    isFree: isFreeProps,
    theme,
    previousItem,
    setItemFree,
    conditionTextMapping,
    isCorporate
  } = props;

  const {
    ordernr,
    name,
    image,
    currency,
    totalPrice,
    finalPrice,
    quantity: initialCount,
    availability,
    availId,
    productId,
    goodId,
    productUrl,
    subItems,
    units,
    saleCount,
    isNew,
    isSecondHand,
    hiddenSale,
    isSale,
    isFreeDelivery,
    hasGift
  } = getCartItemInfo(item);
  const updateCountTimeout: any = React.useRef(null);
  const [count, setCount] = useState(initialCount);

  const handleCountChange = e => {
    let newCount = e.target.value;

    if (newCount === '0' || newCount === 0) {
      setCount(count);
      if (onCountRemoveFromCart) {
        onCountRemoveFromCart(productId, goodId, name);
      }
      return;
    }

    setCount(newCount);

    if (updateCountTimeout) {
      clearTimeout(updateCountTimeout.current);
    }

    updateCountTimeout.current = setTimeout(() => {
      if (newCount < 1) {
        newCount = 1;
      }
      let newCountNumber = parseFloat(newCount);
      newCountNumber = parseFloat(newCount);
      const countDiff = -(+initialCount - +newCountNumber);
      addToCart(item, countDiff);
      setCount(newCount);
    }, 1000);
  };

  const handleRemoveClick = () => {
    removeFromCart(productId, goodId);
  };

  const isFree = isFreeProps || prop(item, 'sale_info.is_free');
  const howManyMoreGiftsToChoose =
    prop(item, 'sale_info.sale_count') - prop(item, 'chosen_gifts.length') < 0
      ? 0
      : prop(item, 'sale_info.sale_count') - prop(item, 'chosen_gifts.length');

  const handleSetFreeClick = e => {
    e.preventDefault();
    setItemFree(productId, goodId);
  };

  const condition = item?.product?.product_condition;
  const conditionText =
    conditionTextMapping && condition
      ? conditionTextMapping.find(ctm => ctm.condition == condition)?.text
      : null;

  return (
    <>
      <Wrapper>
        {prop(item, 'sale_info.sale_id') &&
          prop(item, 'sale_info.sale_id') ===
            prop(previousItem, 'sale_info.sale_id') && (
            <StyledPlusIconWrapper>
              <SvgIcon
                fill={'white'}
                icon={IconType.plus}
                viewBox={'0 0 8 8'}
                width={12}
                height={12}
              />
            </StyledPlusIconWrapper>
          )}
        <ImageNameRow>
          <StyledTags 
              isVertical={true}
              tagWidth={36}
              tagHeight={36}
              isNew={isNew}
              isSecondHand={isSecondHand}
              hiddenSale={hiddenSale}
              isSale={
                isSecondHand
                  ? false
                  : isSale
              }
              isFreeDelivery={isB2B ? false : isFreeDelivery}
              hasGift={hasGift}
          />
          <StyledLink to={productUrl}>
            <Image
              alt={`${__('Obrázok ku produktu')} ${name ? name : ''}`}
              src={image}
            />
          </StyledLink>
          <StyledLink to={productUrl}>
            <FlexCol>
                <Name>{`${name}`}</Name>
                <Plu>{`${ordernr}`}</Plu>
                {
                  availId != 1 && isNew? <Availability isWaiting={true}> {__("Očakávame")} </Availability>:
                  <Availability availId={availId} isCondition={!!conditionText}>{`${
                    conditionText ? conditionText : availability
                  }`}</Availability>
                }
            </FlexCol>
          </StyledLink>
          {/*
          {prop(item, 'sale_info.can_be_free') &&
            prop(item, 'sale_info.total_sale_count') !== saleCount && (
              <StyledSetFreeButton onClick={handleSetFreeClick}>
                {__('Nastaviť ako položku zdarma')}
              </StyledSetFreeButton>
            )}
          */}
        </ImageNameRow>
        <PriceRow>
          <UnitPrice>
            {isFree ? (
              __('Zadarmo')
            ) : subItems.length > 0 ? (
              <>
                <FlexCol>
                  {subItems[0].count} ks -{' '}
                  {formatPrice(
                    isB2B
                      ? subItems[0].sumprice.priceWithoutVat
                      : subItems[0].sumprice.price,
                    currency,
                  )}
                </FlexCol>
                <FlexCol>
                  {subItems[1].count} ks -{' '}
                  {formatPrice(
                    isB2B
                      ? subItems[1].sumprice.priceWithoutVat
                      : subItems[1].sumprice.price,
                    currency,
                  )}
                </FlexCol>
              </>
            ) : (
              <FlexCol>{formatPrice(finalPrice, currency)}</FlexCol>
            )}
          </UnitPrice>
          <FlexRowCenterVertical>
            {isFree ? (
              `${count} ${units || 'ks'}`
            ) : (
              <>
                {' '}
                <CountInput
                  value={count}
                  type="number"
                  min="0"
                  /* tslint:disable-next-line:jsx-no-lambda */
                  onChange={e => handleCountChange(e)}
                />
                <UnitPrice>{units}</UnitPrice>
              </>
            )}
          </FlexRowCenterVertical>
          <Price>
            {isFree ? __('Zadarmo') : formatPrice(totalPrice, currency)}
            {isFree && (
              <SvgIcon
                icon={IconType.gift}
                width={24}
                height={24}
                fill={theme.colors.primary}
                marginLeft={16}
              />
            )}
          </Price>
          {isFreeProps ? (
            <SvgIcon
              icon={IconType.percentage}
              width={24}
              height={24}
              fill={theme.colors.primary}
              title={__('Akcia')}
            />
          ) : (
            <SvgIcon
              icon={IconType.trash}
              width={24}
              height={24}
              cursor={'pointer'}
              fill={'#CCCCCC'}
              onClick={handleRemoveClick}
            />
          )}
        </PriceRow>
      </Wrapper>
      {prop(item, 'chosen_gifts.length') > 0 &&
        item.chosen_gifts.map((i, index) => {
          return (
            <DsiProductCartTableSaleRow
              key={index}
              item={i}
              originalItem={item}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              isB2B={isB2B}
              availableGifts={
                prop(item, 'sale_info.sale_choose_only')
                  ? prop(item, 'available_gifts')
                  : 0
              }
              updateCart={updateCart}
              itemIndex={index}
              isMobile={true}
              showRemove={true}
            />
          );
        })}
      {prop(item, 'sale_info.sale_choose_only') &&
        prop(item, 'available_gifts')
          .slice(0, howManyMoreGiftsToChoose)
          .map((i, index) => {
            return (
              <DsiProductCartTableSaleRow
                key={index}
                item={null}
                originalItem={item}
                addToCart={addToCart}
                removeFromCart={removeFromCart}
                isB2B={isB2B}
                availableGifts={
                  prop(item, 'sale_info.sale_choose_only')
                    ? prop(item, 'available_gifts')
                    : 0
                }
                updateCart={updateCart}
                itemIndex={-1}
                isMobile={true}
              />
            );
          })}

      {saleCount > 0 && (
        <ProductCartMobileTab
          key={item.good.good_id}
          isFree={true}
          item={{ ...item, count: item.sale_count, sale_count: 0 }}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          isB2B={isB2B}
          updateCart={updateCart}
          theme={theme}
          isCorporate={isCorporate}
        />
      )}

      {item.available_price_gifts.length ? (
        <DsiProductCartTableSaleRow
          key={`price-sale-${item.good.good_id}`}
          item={null}
          originalItem={item}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          isB2B={isB2B}
          availableGifts={prop(item, 'available_price_gifts')}
          updateCart={updateCart}
          itemIndex={-1}
          chooseModalWithPrices={true}
          chooseModalAddToCart={true}
          isMobile={true}
        />
      ) : (
        <></>
      )}
    </>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  padding: ${rem(16)};
  margin-bottom: ${rem(8)};
`;

const ImageNameRow = styled(FlexRow)`
  width: 100%;
  margin-bottom: ${rem(24)};
  position: relative;
`;

const StyledSetFreeButton = styled(SetFreeButton)`
  margin-left: auto;
`;

const PriceRow = styled(FlexRowCenterVertical)`
  justify-content: space-between;
`;

const Image = styled.img`
  width: ${rem(40)};
  height: ${rem(40)};
  margin-right: ${rem(16)};
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 500;
`;

const Plu = styled(TextP)`
  font-size: ${rem(12)};
  color: ${({ theme }) => theme.blogColors.gray};
`;

const Availability = styled(TextP)<{ availId: number; isCondition: boolean; isWaiting: boolean }>`
  font-size: ${rem(14)};
  color: ${({ theme, availId, isCondition, isWaiting }) =>
    isCondition
      ? theme.colors.stockCountCondition
      : isWaiting
      ? theme.tagColors.new
      : availId === 1
      ? theme.colors.successColor
      : theme.colors.dangerColor};
`;

const UnitPrice = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  font-size: ${rem(14)};
`;

const Price = styled(UnitPrice)`
  font-weight: 500;
`;

const CountInput = styled.input`
  border: ${({ theme }) => theme.borders.primary};
  border-radius: ${rem(4)};
  margin-right: ${rem(8)};
  width: ${rem(56)};
  height: ${rem(40)};
  text-align: center;
`;

const StyledPlusIconWrapper = styled(PlusIconWrapper)`
  left: ${rem(40)};
`;

const StyledTags = styled(Tags)`
  padding: 0;
  padding-left: 0;
  top: 0;
  left: 0;
  transform: scale(0.65);
  transform-origin: top left;
  position: relative;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const WithThemeProductCartMobileTab: any = withTheme(ProductCartMobileTab);
export { WithThemeProductCartMobileTab as ProductCartMobileTab };
